import styled from "styled-components";
import { getDirection } from "../../../../../common-deprecated/themes/common";
import * as TooltipStyles from "../../../../../common-deprecated/styles/v2/toyota/components/Tooltip";

export const Description = styled.div`
    margin-block-start: calc(var(--spacing-3) / 2);

    @supports not (margin-block: 0) {
        margin-top: calc(var(--spacing-3) / 2);
    }
`;

export const List = styled.ul`
    margin-block-start: var(--spacing-4);
    padding: 0;

    li {
        display: flex;
        align-items: center;
        align-self: stretch;
        gap: var(--spacing-1);
        font-family: var(--font-book);
        font-size: 1.3rem;
        line-height: 2rem;
        color: var(--color-primary-black);

        &:not(:nth-last-child(1)) {
            margin-block-end: var(--spacing-1);
        }

        ${TooltipStyles.TooltipButton} {
            color: var(--color-primary-black);
        }
    }

    @supports not (margin-block: 0) {
        margin-top: var(--spacing-4);

        li {
            &:not(:nth-last-child(1)) {
                margin-bottom: var(--spacing-1);
            }
        }

        svg {
            margin-${getDirection("right")}: var(--spacing-1);
        }
    }
`;

export const IconWrapper = styled.span<{ highlight?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ highlight }) => (highlight ? "var(--color-primary-red)" : "var(--color-primary-dark)")};
`;
